// extracted by mini-css-extract-plugin
module.exports = {"address-item":"style_address-item__EIEB4"};